import styles from './PageProductValuePropositions.module.css';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function PageProductValuePropositionsTestimonials({
  valuePropositionProductSku,
  iconUrl,
  dashUrl,
  testimonials,
}) {
  const { theme } = useSearchParamOrDefaultProps();

  return (
    <>
      <div
        className={classNames(
          styles.testimonialIconWrapper,
          styles.investingClubProductBackgroundColor,
        )}
      >
        <img src={iconUrl} />
      </div>
      <div
        className={classNames(styles.detailsWrapper, styles.testimonial, {
          [styles.proProductBackgroundColor]:
            theme === 'pro' ||
            (theme === 'allAccess' && valuePropositionProductSku === 'pro'),
          [styles.investingClubProductBackgroundColor]:
            theme === 'investingClub' ||
            (theme === 'allAccess' &&
              valuePropositionProduct === 'investingClub'),
          [styles.allAccessProductBackgroundColor]:
            theme === 'allAccess' && valuePropositionProductSku === 'allAccess',
          [styles.registeredOnlyProductBackgroundColor]:
            theme === 'registeredOnly' ||
            (theme === 'allAccess' &&
              valuePropositionProductSku === 'registeredOnly'),
        })}
      >
        <div className={styles.testimonialWrapper}>
          {testimonials.map(({ quote, attribute }) => (
            <div className={styles.testimonialContainer} key={attribute}>
              <div className={styles.testimonialQuote}>
                {quote.map((text, index) => {
                  if (index % 2) {
                    return <strong key={`${text}_${index}`}>{text}</strong>;
                  } else {
                    return `${text}`;
                  }
                })}
              </div>
              <div className={styles.testimonialAttribute}>
                <img src={dashUrl} />
                {attribute}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

PageProductValuePropositionsTestimonials.propTypes = {
  valuePropositionProductSku: PropTypes.string,
  iconUrl: PropTypes.string,
  dashUrl: PropTypes.string,
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      quote: PropTypes.arrayOf(PropTypes.string),
      attribute: PropTypes.string,
    }),
  ),
};

export default PageProductValuePropositionsTestimonials;
